module.exports = __webpack_public_path__ + "static/img/img-more.b169cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matching/img-more.png
// module id = RIAs
// module chunks = 156